import React, { memo } from 'react'
import { Message } from '@paypalcorp/worldready-react'
import {
  Container,
  Row,
  Col,
  HeadingText,
  BodyText,
  Button,
} from '@paypalcorp/pp-react'
import serverData from '../../utils/server-data'
import PrivacyHubHome from './home'
import PrivacyHubPrinciples from './PrivacyHubPrinciples'
import PrivacyHubData from './PrivacyHubData'
import PrivacyHubOthers from './PrivacyHubOthers'
import PrivacyHubBusiness from './PrivacyHubBusiness'
import { PrivacyHubLink } from './common'
import { func } from 'prop-types'

const PrivacyHubFAQSection = memo(() => (
  <div id="privacy-hub-faq-section">
    <Container fluid>
      <Row noGutters align="center">
        <Col className="privacy-hub-text-align-center">
          <HeadingText
            className="privacy-hub-large-text privacy-hub-text-color-white"
            id="privacyHubFAQTitle"
          >
            <Message id="privacyhub.faq.heading" />
          </HeadingText>
          <BodyText
            className="privacy-hub-body-text privacy-hub-faq-description privacy-hub-text-color-white"
            id="privacyHubFAQBody"
          >
            <Message id="privacyhub.faq.body" />
          </BodyText>
          <a href="/smarthelp/contact-us/privacy" id="privacyHubFAQLink">
            <Button
              inverse
              className="privacy-hub-faq-button privacy-hub-button-text"
              name="faq"
              id="privacyHubFAQButton"
            >
              <Message id="privacyhub.faq.button" />
            </Button>
          </a>
        </Col>
      </Row>
    </Container>
  </div>
))

PrivacyHubFAQSection.displayName = 'PrivacyHubFAQSection'

const PrivacyHubSignUpSection = memo(() => (
  <div id="privacy-hub-signup-section">
    <Container fluid>
      <Row noGutters align="center">
        <Col className="privacy-hub-text-align-center">
          <HeadingText
            size="sm"
            className="privacy-hub-title-text"
            id="privacyHubSignUpTitle"
          >
            <Message id="privacyhub.signup.heading" />
          </HeadingText>
          <BodyText
            className="privacy-hub-body-text privacy-hub-signup-description"
            id="privacyHubSignUpBody"
          >
            <Message id="privacyhub.signup.body" />
          </BodyText>
          <PrivacyHubLink
            name="signUp"
            message="privacyhub.signup.link"
            href="/webapps/mpp/account-selection"
            id="privacyHubSignUpLink"
          />
        </Col>
      </Row>
    </Container>
  </div>
))

PrivacyHubSignUpSection.displayName = 'PrivacyHubSignUpSection'

const PrivacyHub = ({ onSectionClick }) => {
  const { selectedSubComponent, language } = serverData
  const className = language === 'zh' ? 'cn' : ''

  const SubComponent = {
    default: <PrivacyHubHome onSectionClick={onSectionClick} />,
    principles: <PrivacyHubPrinciples />,
    data: <PrivacyHubData />,
    others: <PrivacyHubOthers />,
    business: <PrivacyHubBusiness />,
  }

  return (
    <div id="privacy-hub" className={className}>
      {selectedSubComponent
        ? SubComponent[selectedSubComponent]
        : SubComponent.default}
      <PrivacyHubFAQSection />
      <PrivacyHubSignUpSection />
    </div>
  )
}

PrivacyHub.propTypes = {
  onSectionClick: func.isRequired,
}

export default PrivacyHub
